import { Splitter, SplitterPanel } from 'primereact/splitter';

import downloadFile from '../../../utils/DownloadFile';
import { useDispatch, useSelector } from 'react-redux';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

import DocumentView from '../../../common/DocumentView';

const BuyerCNDNandInvoiceSplitView = (props) => {

    const { buyerCNDNURL, buyerInvoiceURL } = props

    const dispatch = useDispatch()


    const searchParams = useSelector(state => state.buyerCreditNotes.searchParams)

    const handleDownloadPDF = (pdfURL) => {
        if(pdfURL){
            downloadFile(pdfURL, `${pdfURL === buyerCNDNURL ? searchParams.dataType === "creditNote" ? "CreditNote" : "DebitNote" : "BuyerInvoice"}.pdf`)
        }
        else{
            dispatch(raiseToast({severity:'error', detail: 'PDF was not found', life: 3000}))
        }
    }

    const renderPDF = (pdfURL) => {
        return (
            <>
                {
                    pdfURL ?
                        <DocumentView fileUrl={pdfURL} showZoomControl={true} />
                        : <p className='text-center'>The pdf file is not found</p>
                }
            </>
        )
    }

    return(
        <div style={{ height: 'calc(100vh - 100px)' }}>
            <Splitter style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                <SplitterPanel style={{ width: '50%', height: '88%', overflow: 'auto' }}>
                    {renderPDF(buyerCNDNURL)}
                </SplitterPanel>
                <SplitterPanel style={{ width: '50%', height: '88%', overflow: buyerInvoiceURL?.includes('.pdf') ? 'auto' : 'hidden' }}>
                    {buyerInvoiceURL?.includes('.pdf') ? renderPDF(buyerInvoiceURL) : <iframe title='pdf viewer' src={buyerInvoiceURL} className='w-full h-full' />}
                </SplitterPanel>
            </Splitter>
        </div>
    )
}

export default BuyerCNDNandInvoiceSplitView